export const memeTemplates = [
  { top: true, bottom: true },
  { top: true, bottom: false },
  { top: false, bottom: true }
];
